module.exports = __webpack_public_path__ + "media/telphone1.226468f0.mp3";